/**
 * @description
 *
 * Перезаписывает содержимое DOM элемента
 *
 * @param {string} selector - элемент у которого меняем содержимое
 * @param {string} html - на что перезаписываем содержимое DOM элемента
 */

function replaceInnerHtml(selector, html) {
  const el = document.querySelector(selector)

  if (!el) {
    return
  }

  if (typeof html !== 'string') {
    return
  }

  el.innerHTML = html
}

export default replaceInnerHtml
